import { Component, OnInit } from '@angular/core';
import { ComunicacionService } from '../_services/comunicacion.service';
import { MatDialog } from '@angular/material/dialog';
import { Novedad } from '../_models/novedad.model';
import { DialogCrearEditarNovedadComponent } from '../dialog-crear-editar-novedad/dialog-crear-editar-novedad.component';
import { DialogConfirmacionComponent } from '../dialog-confirmacion/dialog-confirmacion.component';
import { DialogMensajeComponent } from '../dialog-mensaje/dialog-mensaje.component';

@Component({
  selector: 'app-novedades',
  templateUrl: './novedades.component.html',
  styleUrls: ['./novedades.component.css']
})
export class NovedadesComponent implements OnInit {
  novedades: Novedad[] = [];
  loading = false;
  usuarioLog: string;
  hayError = false;

  constructor(private comunicacionService: ComunicacionService, private dialog: MatDialog) {
    this.usuarioLog = JSON.parse(sessionStorage.getItem('currentUser') || '{}').usuario;
  }

  ngOnInit(): void {
    this.cargarNovedades();
  }

  cargarNovedades(): void {
    this.loading = true;
    const params = { desde: 0, cuantas: 10, usuarioEstado: this.usuarioLog };

    this.comunicacionService.obtenerNovedadesActivas(params).subscribe({
      next: (resp: any) => {
        this.novedades = resp;
        this.loading = false;
      },
      error: () => {
        this.loading = false; 
        this.hayError=true;
      }
    });
  }

  agregarNovedad(): void {
    const dialogRef = this.dialog.open(DialogCrearEditarNovedadComponent, {
      width: '500px',
      data: null
    });

    dialogRef.afterClosed().subscribe(resultado => {
      if (resultado) {
        this.cargarNovedades();
      }
    });
  }

  editarNovedad(novedad: any) {
    const dialogRef = this.dialog.open(DialogCrearEditarNovedadComponent, {
      width: '500px',
      data: novedad
    });

    dialogRef.afterClosed().subscribe(resultado => {
      if (resultado) {
        this.cargarNovedades();
      }
    });
  }

  eliminarNovedad(novedad: any) {
    const dialogRef = this.dialog.open(DialogConfirmacionComponent, {
      width: '400px',
      data: '¿Desea eliminar esta novedad?'
    });

    dialogRef.afterClosed().subscribe(confirmado => {
      if (confirmado) {
        const payload = {
          idComunicacion: novedad.idComunicacion,
          usuarioEstado: this.usuarioLog
        };

        this.comunicacionService.cambiarEstadoNovedad(payload).subscribe({
          next: res => {
            this.dialog.open(DialogMensajeComponent, {
              width: '400px',
              data: { mensaje: 'Novedad eliminada correctamente', ok: true }
            }).afterClosed().subscribe(() => {
              this.cargarNovedades();
            });
          },
          error: err => {
            console.error(err);
            this.dialog.open(DialogMensajeComponent, {
              width: '400px',
              data: { mensaje: 'Ocurrió un error al eliminar la novedad', ok: false }
            });
          }
        });
      }
    });
  }

}